import React, { FC, SVGAttributes } from 'react'

const ChevronRightIcon: FC<SVGAttributes<SVGElement>> = ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
        <path fill="#fff" d="M8.778 8l-4.072 3.96 1.254 1.216L11.294 8 5.96 2.823 4.706 4.04 8.778 8z"></path>
    </svg>
)

export default ChevronRightIcon
